import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CircleAlert, CircleCheck, Info, X } from "lucide-react";
import { createContext, useCallback, useContext, useMemo, useRef, useState, } from "react";
import { cn } from "../lib/cn.js";
const ToastContext = createContext(null);
export function useToast() {
    const toast = useContext(ToastContext);
    if (!toast)
        throw new Error("useToast yalnızca <ToastProvider> içinde kullanılabilir");
    return toast;
}
const icons = { success: CircleCheck, danger: CircleAlert, info: Info };
const tones = {
    success: "border-success/40",
    danger: "border-destructive/50",
    info: "border-info/40",
};
/** Bildirimler canlı bölgede duyurulur: hata → `assertive`, diğerleri → `polite`. */
export function ToastProvider({ children }) {
    const [items, setItems] = useState([]);
    const nextId = useRef(1);
    const dismiss = useCallback((id) => setItems((current) => current.filter((item) => item.id !== id)), []);
    const toast = useCallback((options) => {
        const id = nextId.current++;
        const tone = options.tone ?? "info";
        setItems((current) => [
            ...current.slice(-3),
            { id, tone, title: options.title, description: options.description },
        ]);
        const duration = options.duration ?? (tone === "danger" ? 8000 : 4500);
        if (duration > 0)
            setTimeout(() => dismiss(id), duration);
    }, [dismiss]);
    const value = useMemo(() => toast, [toast]);
    return (_jsxs(ToastContext.Provider, { value: value, children: [children, _jsx("div", { className: "pointer-events-none fixed bottom-4 right-4 z-[60] flex w-[min(24rem,calc(100vw-2rem))] flex-col gap-2", children: items.map((item) => {
                    const Icon = icons[item.tone];
                    return (_jsxs("div", { role: item.tone === "danger" ? "alert" : "status", className: cn("pointer-events-auto flex items-start gap-3 rounded-md border bg-card p-3 text-sm shadow-lg", tones[item.tone]), children: [_jsx(Icon, { className: cn("mt-0.5 size-4 shrink-0", item.tone === "danger"
                                    ? "text-destructive"
                                    : item.tone === "success"
                                        ? "text-success"
                                        : "text-info"), "aria-hidden": "true" }), _jsxs("div", { className: "grid flex-1 gap-0.5", children: [_jsx("p", { className: "font-semibold", children: item.title }), item.description ? _jsx("p", { className: "text-muted-foreground", children: item.description }) : null] }), _jsx("button", { type: "button", onClick: () => dismiss(item.id), className: "text-muted-foreground hover:text-foreground", "aria-label": "Bildirimi kapat", children: _jsx(X, { className: "size-4", "aria-hidden": "true" }) })] }, item.id));
                }) })] }));
}
//# sourceMappingURL=toast.js.map